/* global localStorage */

import Account from '../models/Account'
import * as MutationTypes from './mutation-types'

const state = {
    account: Account.from(localStorage.token)
}

const mutations = {
  [MutationTypes.LOGIN] (state) {
    state.account = Account.from(localStorage.token)
  },
  [MutationTypes.LOGOUT] (state) {
    state.account = null
  }
}

const getters = {
  currentAccount (state) {
    return state.account
  },
  getAccount (state) {
    return state.account
  }
}

const actions = {
  login ({ commit }) {
    commit(MutationTypes.LOGIN)
  },

  logout ({ commit }) {
    commit(MutationTypes.LOGOUT)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
